import { render, staticRenderFns } from "./MonitoringTables.vue?vue&type=template&id=56a5bdb0&"
import script from "./MonitoringTables.vue?vue&type=script&lang=ts&"
export * from "./MonitoringTables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports